import { Marker as GoogleMapsMarker } from '@react-google-maps/api'
import { observer } from 'mobx-react'
import React, { useState } from 'react'
import { Marker as MapBoxMarker } from 'react-map-gl'

import { imageUrls } from '../../constants/imageConstants'
import { useMapsUtilityContext } from '../../hooks/useMapsUtilityContext'
import { MapCoordinates } from '../../types'

import * as Styles from './styles'

interface Props {
   coordinates: MapCoordinates
   isDraggable: boolean
   markerNumber: number
   onMove: (coordinates: MapCoordinates) => void
   onClick: () => void

   shouldShowMarkerNumber?: boolean
}

const MapMarker = (props: Props): React.ReactElement => {
   const {
      coordinates,
      isDraggable,
      markerNumber,
      onMove,
      onClick,
      shouldShowMarkerNumber = true
   } = props

   const [isDragging, setIsDragging] = useState(false)

   const { serviceProvidersConfig } = useMapsUtilityContext()

   switch (serviceProvidersConfig.maps.serviceProvider) {
      case 'GOOGLE_MAPS': {
         const onMarkerDrag = (dragEvent: google.maps.MapMouseEvent): void => {
            if (!dragEvent.latLng) return

            const newCoordinates: MapCoordinates = {
               lat: dragEvent.latLng.lat(),
               lng: dragEvent.latLng.lng()
            }

            onMove(newCoordinates)
         }

         return (
            <GoogleMapsMarker
               position={coordinates}
               onDragEnd={onMarkerDrag}
               onClick={onClick}
               draggable={isDraggable}
               icon={{
                  url: shouldShowMarkerNumber
                     ? imageUrls.mapMarker
                     : imageUrls.mapMarkerDot,
                  scaledSize: new google.maps.Size(36, 44, 'px', 'px')
               }}
               label={
                  shouldShowMarkerNumber
                     ? {
                          text: markerNumber.toString(),
                          className: Styles.googleMapsMarkerText,
                          color: 'white'
                       }
                     : undefined
               }
               options={{
                  crossOnDrag: false,
                  zIndex: markerNumber
               }}
            />
         )
      }
      case 'MAPBOX': {
         return (
            <MapBoxMarker
               longitude={coordinates.lng}
               latitude={coordinates.lat}
               color='red'
               onDragStart={() => {
                  setIsDragging(true)
               }}
               onDragEnd={dragEvent => {
                  onMove(dragEvent.lngLat)
                  setTimeout(() => setIsDragging(false), 300)
               }}
               onClick={event => {
                  event.originalEvent.stopPropagation()

                  if (isDragging) return
                  onClick()
               }}
               draggable={isDraggable}
            >
               {shouldShowMarkerNumber ? (
                  <div className='relative'>
                     <div className={Styles.mapboxMarkerContainer}>
                        <img src={imageUrls.mapMarker} height={44} width={36} />
                        <p className={Styles.mapboxMarkerText}>
                           {markerNumber}
                        </p>
                     </div>
                  </div>
               ) : null}
            </MapBoxMarker>
         )
      }
   }
}

export default observer(MapMarker)
